// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2zdNv","productName":"Table_productName__1TTV2"};